import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const ChevronRight = ({ fill: fillProp }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.icon.default;

  return (
    <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7807 25.5005L12.2578 23.9776L19.2703 16.9651L12.2578 9.9526L13.7807 8.42969L22.3161 16.9651L13.7807 25.5005Z"
        fill={fill}
      />
    </svg>
  );
};
